export default "__VITE_ASSET__B8KC$svS__"